/* TummyHush creator-video test. Band PDP, all devices.
   Arm V shows the block; arm C keeps it hidden. QA skips attribution. */
(function () {
  'use strict';
  var block = document.querySelector('[data-th-vid-ab]');
  if (!block) return;

  var share = Math.max(0, Math.min(100, Number(block.getAttribute('data-share')) || 0));
  var force = block.getAttribute('data-force') || 'none';
  var param = (location.search.match(/[?&]th_vid_ab=([VC])(?:&|$)/) || [])[1];
  var qa = false;
  var bucket = null;
  if (param) { bucket = param; qa = true; }
  else if (force === 'V' || force === 'C') { bucket = force; qa = true; }
  else if (share > 0) {
    var stored = null;
    try { stored = localStorage.getItem('th_vid_ab'); } catch (error) { /* Storage may be blocked. */ }
    if (stored === 'V' || stored === 'C') bucket = stored;
    else {
      bucket = Math.random() * 100 < share ? 'V' : 'C';
      try { localStorage.setItem('th_vid_ab', bucket); } catch (error) { /* Keep the in-memory bucket. */ }
    }
  }
  if (!bucket) return;

  if (bucket === 'V') {
    // Posters load only for arm V, so the control arm downloads nothing extra.
    block.querySelectorAll('img[data-poster]').forEach(function (img) { img.src = img.getAttribute('data-poster'); });
    block.removeAttribute('hidden');
  }
  if (bucket === 'V') {
    block.querySelectorAll('.th-vid-card').forEach(function (card) {
      card.addEventListener('click', function () {
        var img = card.querySelector('img');
        if (!img) return;
        var video = document.createElement('video');
        video.controls = true;
        video.playsInline = true;
        video.preload = 'auto';
        video.poster = img.src;
        // Assign the source only after a tap: no video requests during page load.
        video.src = card.getAttribute('data-src');
        function pauseOthers() {
          block.querySelectorAll('video').forEach(function (other) {
            if (other !== video) other.pause();
          });
        }
        pauseOthers();
        video.addEventListener('play', pauseOthers);
        img.replaceWith(video);
        card.classList.add('is-playing');
        if (!qa) ga('th_vid_play', { video: Number(card.getAttribute('data-video')) });
        try {
          var playing = video.play();
          if (playing && typeof playing.catch === 'function') {
            playing.catch(function () { /* Native controls allow a retry. */ });
          }
        } catch (error) { /* Native controls allow a retry. */ }
      }, { once: true });
    });
  }
  if (qa) return;

  function ga(name, params) {
    try { if (typeof gtag === 'function') gtag('event', name, params); } catch (error) { /* Optional analytics. */ }
  }

  // One request at a time; a cart update that arrives mid-request re-runs the check once it finishes.
  var stamping = false, again = false;
  function done() { stamping = false; if (again) { again = false; stamp(); } }
  function stamp() {
    if (stamping) { again = true; return; }
    if (typeof fetch !== 'function') return;
    stamping = true;
    try {
      fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
        return response.json();
      }).then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (!cart || !(cart.item_count > 0) || attrs.th_vid_ab === bucket) return;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { th_vid_ab: bucket } })
        });
      }).catch(function () { /* Attribution only. */ }).then(done);
    } catch (error) { done(); /* Fetch may fail synchronously. */ }
  }

  try { if (typeof gtag === 'function') gtag('set', 'user_properties', { vid_ab_bucket: bucket }); } catch (error) { /* Optional analytics. */ }
  var exposed = false;
  try { exposed = sessionStorage.getItem('th_vid_ab_exposed') === '1'; } catch (error) { /* Optional analytics. */ }
  if (!exposed && typeof gtag === 'function') {
    try { sessionStorage.setItem('th_vid_ab_exposed', '1'); } catch (error) { /* This execution still emits only once. */ }
    ga('th_vid_exposed_' + bucket);
  }

  var sentinel = document.querySelector('[data-th-vid-sentinel]');
  var seen = false;
  try { seen = sessionStorage.getItem('th_vid_ab_seen') === '1'; } catch (error) { /* Optional analytics. */ }
  if (!seen && sentinel && typeof IntersectionObserver === 'function' && typeof gtag === 'function') {
    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (!seen && entries[i].isIntersecting) {
          seen = true;
          try { sessionStorage.setItem('th_vid_ab_seen', '1'); } catch (error) { /* This execution still emits only once. */ }
          ga('th_vid_seen_' + bucket);
          observer.disconnect();
        }
      }
    }, { threshold: 0 });
    observer.observe(sentinel);
  }

  stamp();
  /* PUB_SUB_EVENTS is a top-level const, not a window property. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { stamp(); });
  }
})();
